// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_d8-2";
export var aiChatCartContainerExit = "_d8-4";
export var aiChatContainerLarge = "_d8-0";
export var aiChatContainerSmall = "_d8-1";
export var aiChatIcon = "_d8-6";
export var slideInFromRight = "_d8-3";
export var slideOutToRight = "_d8-5";